export default __webpack_public_path__ + "static/media/notifications.f253ae26.svg";